jQuery(document).ready(function($){

    $('.header__search input').focusin(function() {
        $(this).parents('.header__search__form').addClass('focused');
    });

    $('.header__search input').focusout(function() {
        $(this).parents('.header__search__form').removeClass('focused');
    });

});
